/* eslint-disable @typescript-eslint/no-extra-semi */
export default function addDefaultSrc(url: string) {
  return (ev: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = ev.target as HTMLImageElement
    // Prevent infinite loop if the fallback URL also fails to load
    if (target.src !== url) {
      target.src = url
    }
  }
}
